import { Link } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { ROUTES } from '@/routes/routes'
import { useCurrentHousehold } from '@/hooks/useCurrentHousehold'

/** Persistent bar shown across the app once a household's trial has lapsed unpaid. Deliberately
 *  not dismissible — the household is read-only until someone subscribes, and every hidden
 *  Add/Edit control would otherwise be unexplained. */
export function TrialEndedBanner() {
  const { role } = useCurrentHousehold()
  const isOwner = role === 'OWNER'

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[var(--fl-warning-bg)] px-4 py-2 text-center text-sm text-[var(--fl-warning-text)]"
    >
      <Lock size={14} className="shrink-0" aria-hidden="true" />
      <span>
        Your free trial has ended. Your data is read-only —{' '}
        {isOwner
          ? 'subscribe to start tracking expenses again.'
          : 'ask the household owner to subscribe to start tracking expenses again.'}
      </span>
      <Link to={ROUTES.APP.SETTINGS_BILLING} className="font-semibold underline underline-offset-2">
        {isOwner ? 'Choose a plan' : 'View plans'}
      </Link>
    </div>
  )
}
